// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentTableWrapper__f3yDe {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 270px);
  overflow: auto;
  box-shadow: var(--table-box-shadow);
}
.equipmentTableWrapper__f3yDe::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.equipmentTableWrapper__f3yDe::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.equipmentTableWrapper__f3yDe::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.equipmentTableWrapper__f3yDe::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 875px) {
  .equipmentTableWrapper__f3yDe {
    max-height: calc(100vh - 230px);
  }
}

.equipmentTable__D2Wik {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.equipmentTable__D2Wik th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
@media (max-width: 1300px) {
  .equipmentTable__D2Wik th {
    padding: 16px 10px;
  }
}
@media (max-width: 1015px) {
  .equipmentTable__D2Wik th {
    padding: 16px 5px;
  }
}

.sortIcon__EXO0U {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__EXO0U path {
  fill: var(--tables-title-icon);
}

.activeSort__wJqIo path {
  fill: var(--tables-primary-row-icon);
}

.tableFooter__OtXtz {
  margin-top: 25px;
  height: 24px;
  text-align: right;
}
@media (max-width: 875px) {
  .tableFooter__OtXtz {
    margin-top: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/components/EquipmentTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,mCAAA;AAzEF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;AA4DE;EATF;IAUI,+BAAA;EAzDF;AACF;;AA4DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAzDF;AA2DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAzDJ;AA2DI;EAfF;IAgBI,kBAAA;EAxDJ;AACF;AA0DI;EAnBF;IAoBI,iBAAA;EAvDJ;AACF;;AA2DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAxDF;AA0DE;EACE,8BAAA;AAxDJ;;AA6DE;EACE,oCAAA;AA1DJ;;AA8DA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;AA3DF;AA6DE;EALF;IAMI,gBAAA;EA1DF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 270px);\n  overflow: auto;\n  box-shadow: var(--table-box-shadow);\n\n  @include scrollBar;\n\n  @media (max-width: 875px) {\n    max-height: calc(100vh - 230px);\n  }\n}\n\n.equipmentTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    @media (max-width: 1300px) {\n      padding: 16px 10px;\n    }\n\n    @media (max-width: 1015px) {\n      padding: 16px 5px;\n    }\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.tableFooter {\n  margin-top: 25px;\n  height: 24px;\n  text-align: right;\n\n  @media (max-width: 875px) {\n    margin-top: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentTableWrapper": `equipmentTableWrapper__f3yDe`,
	"equipmentTable": `equipmentTable__D2Wik`,
	"sortIcon": `sortIcon__EXO0U`,
	"activeSort": `activeSort__wJqIo`,
	"tableFooter": `tableFooter__OtXtz`
};
module.exports = ___CSS_LOADER_EXPORT___;
